import { v5 as uuidv5 } from 'uuid';

// Generate unique UUID for restaurant based on index
const generateRestaurantUUID = (index) => {
  // Create a deterministic UUID based on restaurant index
  const namespace = '550e8400-e29b-41d4-a716-446655440000'; // Fixed namespace for restaurants
  const name = `restaurant-${index}`; // Use restaurant index as name
  
  // Generate a deterministic UUID using v5 (namespace + name)
  return uuidv5(name, namespace);
};

// Generate a smaller set of restaurants for better performance
const generateRestaurants = () => {
  const categories = ['chinese', 'western', 'japanese', 'korean', 'thai', 'indian', 'vietnamese', 'italian', 'cafe', 'fastfood', 'dessert', 'bakery', 'seafood', 'bbq', 'hotpot', 'vegetarian', 'breakfast'];
  const locations = ['central', 'admiralty', 'wanchai', 'causewayBay', 'tinhau', 'mongkok', 'tsimshatsui', 'jordan', 'yaumatei', 'princeedward', 'sheungwan', 'saiwanho', 'quarrybay', 'taikoo', 'shatin', 'taipo', 'fanling', 'yuenlong', 'tuenmun'];
  
  const locationNames = {
    central: '中環', admiralty: '金鐘', wanchai: '灣仔', causewayBay: '銅鑼灣', tinhau: '天后',
    mongkok: '旺角', tsimshatsui: '尖沙咀', jordan: '佐敦', yaumatei: '油麻地', princeedward: '太子',
    sheungwan: '上環', saiwanho: '西灣河', quarrybay: '鰂魚涌', taikoo: '太古', shatin: '沙田',
    taipo: '大埔', fanling: '粉嶺', yuenlong: '元朗', tuenmun: '屯門'
  };

  const restaurantNames = [
    // A names
    'Amber Restaurant', 'Aria Café', 'Aqua Luna', 'Artisan Kitchen', 'Asian Fusion', 'Angel Wings', 'Authentic Taste', 'Azure Bistro',
    // B names  
    'Blue Moon', 'Bamboo Garden', 'Burger Station', 'Bangkok Street', 'Bistro Belle', 'Bright Star', 'Bold Bites', 'Blissful Bowls',
    // C names
    'Crystal Palace', 'Café Central', 'Corner Deli', 'Curry House', 'Cha Chaan Teng', 'Cherry Blossom', 'Coastal Kitchen', 'Creative Cuisine',
    // D names
    'Dragon Palace', 'Divine Kitchen', 'Dessert Heaven', 'Dumpling Master', 'Deli Corner', 'Diamond Dining', 'Deluxe Garden', 'Dynamic Dining',
    // E names
    'Edo Sushi Bar', 'Emerald Garden', 'Express Noodles', 'Elite Café', 'Eastern Delight', 'Elegant Eats', 'Exotic Flavors', 'Energy Kitchen',
    // F names
    'Fusion Kitchen', 'French Corner', 'Fire Dragon', 'Fresh Market', 'Fish & Chips', 'Flavor Factory', 'Fortune Garden', 'Fabulous Food',
    // G names
    'Golden Phoenix', 'Green Garden', 'Grill Master', 'Greek Taverna', 'Grand Buffet', 'Gourmet Gallery', 'Garden Fresh', 'Global Gastronomy',
    // H names
    'Himalaya Curry', 'Hot Pot Heaven', 'Honey Bakery', 'Happy Kitchen', 'Hearty Haven', 'Healthy Habits', 'Heavenly Taste', 'Harbor View',
    // I names
    'Italian Corner', 'Imperial Palace', 'Island Grill', 'Inspired Dining', 'International Flavors', 'Incredible Eats', 'Ivy Restaurant', 'Iconic Kitchen',
    // J names
    'Jade Garden', 'Jazz Café', 'Joyful Kitchen', 'Japanese Garden', 'Jasmine Tea House', 'Juicy Burgers', 'Jungle Curry', 'Just Desserts',
    // K names
    'Korean BBQ House', 'King\'s Palace', 'Kitchen Kingdom', 'Kimchi House', 'Koi Garden', 'Karma Café', 'Kabuki Restaurant', 'Kettle Kitchen',
    // L names
    'Lucky Star Dim Sum', 'Lotus Garden', 'Local Legends', 'Lemon Tree', 'Liberty Kitchen', 'Lively Lounge', 'Lakeside Dining', 'Lavender Café',
    // M names
    'Modern Café', 'Mango Tree', 'Metro Kitchen', 'Moonlight Diner', 'Mountain View', 'Maple Leaf', 'Mediterranean Coast', 'Magic Wok',
    // N names
    'Noodle Master', 'New York Deli', 'Natural Kitchen', 'Night Market', 'Noble House', 'Northern Lights', 'Nourish Bowl', 'Neptune\'s Catch',
    // O names
    'Ocean Fresh', 'Oriental Palace', 'Olive Garden', 'Original Recipe', 'Outdoor Grill', 'Oasis Café', 'Old Town', 'Organic Kitchen',
    // P names
    'Pizza Corner', 'Pearl Restaurant', 'Peaceful Garden', 'Premium Dining', 'Pure Taste', 'Phoenix Rising', 'Panorama View', 'Passion Fruit',
    // Q names
    'Queen\'s Kitchen', 'Quality Quarters', 'Quick Bite', 'Quiet Corner', 'Quaint Café', 'Quantum Kitchen', 'Quinoa Bowl', 'Qing Dynasty',
    // R names
    'Royal Dessert', 'Red Dragon', 'River View', 'Rustic Kitchen', 'Rainbow Café', 'Rising Sun', 'Royal Palace', 'Refined Taste',
    // S names
    'Saigon Street', 'Silver Moon', 'Sunset Grill', 'Spice Garden', 'Star Kitchen', 'Silk Road', 'Serenity Café', 'Seasonal Kitchen',
    // T names
    'Tandoori Palace', 'Taste of Asia', 'Traditional Kitchen', 'Tropical Paradise', 'Tea Garden', 'Terrace Dining', 'Timeless Taste', 'Tokyo Bay',
    // U names
    'Urban Grill', 'Ultimate Dining', 'Unique Flavors', 'Unity Kitchen', 'Upper Deck', 'Uptown Café', 'Universal Kitchen', 'Utopia Restaurant',
    // V names
    'Veggie Delight', 'Victory Kitchen', 'Village Restaurant', 'Vintage Café', 'Valley View', 'Vibrant Kitchen', 'Venice Canal', 'Velvet Lounge',
    // W names
    'Waffle House', 'Waterfront Dining', 'White Lotus', 'Wok Express', 'Warm Welcome', 'Windmill Café', 'Wonderful World', 'Wild Garden',
    // X names
    'Xiao Long Bao', 'Xquisite Dining', 'Xtreme Kitchen', 'Xi\'an Noodles', 'Xing Fu Restaurant', 'Xenial Café', 'Xtra Special', 'Xanadu Palace',
    // Y names
    'Yakitori Bar', 'Yummy Kitchen', 'Yellow River', 'Yin Yang', 'Youthful Dining', 'Yard Kitchen', 'Yaki House', 'Yuzu Restaurant',
    // Z names
    'Zen Garden', 'Zesty Kitchen', 'Zodiac Restaurant', 'Zen Café', 'Zion Kitchen', 'Zephyr Dining', 'Zenith Restaurant', 'Zero Waste Kitchen',
    // Number names
    '24/7 Diner', '7-Eleven Hot Food', '88 Fortune', '168 Restaurant', '360 Dining', '1st Class Kitchen', '2nd Avenue', '3 Stars Restaurant'
  ];

  const chineseNames = [
    '琥珀餐廳', '詠嘆調咖啡', '水月樓', '工匠廚房', '亞洲風味', '天使之翼', '正宗口味', '天藍小酒館',
    '藍月亮', '竹園', '漢堡站', '曼谷街頭', '美麗小館', '明星', '大膽咬', '幸福碗',
    '水晶宮', '中央咖啡廳', '街角熟食店', '咖哩屋', '茶餐廳', '櫻花', '海岸廚房', '創意料理',
    '龍皇酒家', '神廚', '甜品天堂', '餃子大師', '熟食角', '鑽石餐飲', '豪華花園', '動態餐飲',
    '江戶壽司吧', '翡翠花園', '快速麵條', '精英咖啡', '東方美味', '優雅美食', '異國風味', '活力廚房',
    '融合廚房', '法式角落', '火龍', '新鮮市場', '魚薯', '風味工廠', '財富園', '美妙食物',
    '金鳳茶餐廳', '綠色花園', '燒烤大師', '希臘小酒館', '大酒店自助餐', '美食畫廊', '花園新鮮', '全球美食',
    '喜馬拉雅咖哩', '火鍋天堂', '蜂蜜麵包店', '快樂廚房', '豐盛天堂', '健康習慣', '天堂口味', '海港景觀',
    '意大利角落', '皇宮', '島嶼燒烤', '靈感餐飲', '國際風味', '令人難以置信的美食', '常春藤餐廳', '標誌性廚房',
    '翡翠花園', '爵士咖啡', '快樂廚房', '日本花園', '茉莉花茶屋', '多汁漢堡', '叢林咖哩', '只是甜品',
    '韓式燒烤屋', '國王宮殿', '廚房王國', '泡菜屋', '錦鯉花園', '業力咖啡', '歌舞伎餐廳', '水壺廚房',
    '幸運星點心', '蓮花園', '本地傳奇', '檸檬樹', '自由廚房', '活潑休息室', '湖邊餐飲', '薰衣草咖啡',
    '摩登咖啡', '芒果樹', '地鐵廚房', '月光餐廳', '山景', '楓葉', '地中海海岸', '魔法鍋',
    '麵條大師', '紐約熟食店', '天然廚房', '夜市', '貴族屋', '北極光', '滋養碗', '海王捕獲',
    '海洋鮮味', '東方宮殿', '橄欖園', '原始食譜', '戶外燒烤', '綠洲咖啡', '老城', '有機廚房',
    '比薩角落', '珍珠餐廳', '和平花園', '高級餐飲', '純淨口味', '鳳凰崛起', '全景', '百香果',
    '皇后廚房', '品質區', '快咬', '安靜角落', '古雅咖啡', '量子廚房', '藜麥碗', '清朝',
    '皇家甜品', '紅龍', '河景', '鄉村廚房', '彩虹咖啡', '旭日', '皇宮', '精緻口味',
    '西貢街頭', '銀月', '日落燒烤', '香料園', '星廚房', '絲路', '寧靜咖啡', '季節廚房',
    '坦都里宮殿', '亞洲口味', '傳統廚房', '熱帶天堂', '茶園', '露台餐飲', '永恆口味', '東京灣',
    '都市燒烤', '終極餐飲', '獨特風味', '團結廚房', '上層甲板', '上城咖啡', '通用廚房', '烏托邦餐廳',
    '素食樂園', '勝利廚房', '鄉村餐廳', '復古咖啡', '谷景', '充滿活力的廚房', '威尼斯運河', '天鵝絨休息室',
    '窩夫屋', '海濱餐飲', '白蓮花', '鍋快車', '溫暖歡迎', '風車咖啡', '美妙世界', '野生花園',
    '小籠包', '精緻餐飲', '極限廚房', '西安麵條', '幸福餐廳', '好客咖啡', '額外特別', '世外桃源宮',
    '燒鳥酒吧', '美味廚房', '黃河', '陰陽', '青春餐飲', '院子廚房', '燒烤屋', '柚子餐廳',
    '禪園', '活力廚房', '十二生肖餐廳', '禪咖啡', '錫安廚房', '西風餐飲', '頂點餐廳', '零廢廚房',
    '24小時餐廳', '7-11熱食', '88財富', '168餐廳', '360餐飲', '一流廚房', '第二大道', '三星餐廳'
  ];

  const cuisinesByCategory = {
    chinese: ['Cantonese', 'Dim Sum', 'Sichuan', 'Beijing', 'Shanghai', 'Tea Restaurant'],
    western: ['American', 'European', 'British', 'Modern', 'Fine Dining', 'Fusion'],
    japanese: ['Sushi', 'Ramen', 'Yakitori', 'Tempura', 'Bento', 'Traditional'],
    korean: ['Korean BBQ', 'Kimchi', 'Bibimbap', 'Korean Fried Chicken', 'Hot Pot'],
    thai: ['Pad Thai', 'Tom Yum', 'Green Curry', 'Street Food', 'Authentic'],
    indian: ['Curry', 'Tandoori', 'Biryani', 'Naan', 'Vegetarian', 'Spicy'],
    vietnamese: ['Pho', 'Banh Mi', 'Spring Rolls', 'Vietnamese Coffee', 'Fresh'],
    italian: ['Pizza', 'Pasta', 'Risotto', 'Gelato', 'Traditional', 'Modern'],
    cafe: ['Coffee', 'Brunch', 'Pastries', 'Light Meals', 'Desserts', 'Tea'],
    fastfood: ['Burgers', 'Fried Chicken', 'Sandwiches', 'Quick Bites', 'Delivery'],
    dessert: ['Ice Cream', 'Cakes', 'Pastries', 'Chocolate', 'Sweet Treats'],
    bakery: ['Bread', 'Pastries', 'Croissants', 'Fresh Baked', 'Artisan'],
    seafood: ['Fresh Fish', 'Lobster', 'Crab', 'Oysters', 'Grilled', 'Steamed'],
    bbq: ['Grilled Meat', 'Ribs', 'Smoked', 'Outdoor', 'Charcoal', 'Sauce'],
    hotpot: ['Sichuan', 'Mongolian', 'Seafood', 'Vegetarian', 'Spicy', 'Mild'],
    vegetarian: ['Vegan', 'Organic', 'Healthy', 'Plant-based', 'Fresh', 'Natural'],
    breakfast: ['All Day', 'Pancakes', 'Eggs Benedict', 'Waffles', 'Fresh Juice']
  };

  const restaurants = [];

  for (let i = 1; i <= 50; i++) {
    const nameIndex = (i - 1) % restaurantNames.length;
    const categoryIndex = (i - 1) % categories.length;
    const locationIndex = (i - 1) % locations.length;
    
    const category = categories[categoryIndex];
    const location = locations[locationIndex];
    const name = restaurantNames[nameIndex];
    const chineseName = chineseNames[nameIndex];
    const cuisines = cuisinesByCategory[category];
    const selectedCuisines = [cuisines[Math.floor(Math.random() * cuisines.length)]];
    
    // Add second cuisine sometimes
    if (Math.random() > 0.6 && cuisines.length > 1) {
      const secondCuisine = cuisines[Math.floor(Math.random() * cuisines.length)];
      if (secondCuisine !== selectedCuisines[0]) {
        selectedCuisines.push(secondCuisine);
      }
    }

    // Generate realistic ratings (higher chance for good ratings)
    const ratingBase = Math.random();
    let rating;
    if (ratingBase < 0.1) rating = 3.5 + Math.random() * 0.5; // 10% chance for 3.5-4.0
    else if (ratingBase < 0.3) rating = 4.0 + Math.random() * 0.3; // 20% chance for 4.0-4.3
    else if (ratingBase < 0.7) rating = 4.3 + Math.random() * 0.4; // 40% chance for 4.3-4.7
    else rating = 4.7 + Math.random() * 0.3; // 30% chance for 4.7-5.0

    // Price range distribution
    let priceRange;
    const priceRandom = Math.random();
    if (priceRandom < 0.4) priceRange = '$';
    else if (priceRandom < 0.8) priceRange = '$$';
    else priceRange = '$$$';

    // Distance distribution (more restaurants closer)
    let distance;
    const distanceRandom = Math.random();
    if (distanceRandom < 0.3) distance = Math.random() * 1; // 30% within 1km
    else if (distanceRandom < 0.6) distance = 1 + Math.random() * 2; // 30% within 1-3km
    else if (distanceRandom < 0.85) distance = 3 + Math.random() * 5; // 25% within 3-8km
    else distance = 8 + Math.random() * 17; // 15% within 8-25km

    // Delivery fee based on distance and price range
    let deliveryFee;
    if (distance < 2) deliveryFee = 8 + Math.floor(Math.random() * 7);
    else if (distance < 5) deliveryFee = 15 + Math.floor(Math.random() * 10);
    else if (distance < 10) deliveryFee = 20 + Math.floor(Math.random() * 15);
    else deliveryFee = 25 + Math.floor(Math.random() * 20);

    // Adjust delivery fee by price range
    if (priceRange === '$$$') deliveryFee += 5;
    else if (priceRange === '$') deliveryFee = Math.max(5, deliveryFee - 5);

    // Delivery time based on distance and category
    let baseTime = 15;
    if (distance > 5) baseTime += 10;
    if (distance > 10) baseTime += 15;
    if (category === 'chinese' || category === 'fastfood') baseTime -= 5;
    if (category === 'western' && priceRange === '$$$') baseTime += 10;

    const deliveryTimeStart = baseTime + Math.floor(Math.random() * 10);
    const deliveryTimeEnd = deliveryTimeStart + 10 + Math.floor(Math.random() * 15);

    // Popular restaurants (top 30%)
    const popular = i <= 15 || Math.random() < 0.15;

    // Use a simple image ID system for better performance
    const imageId = 1000 + (i * 3); // Generate simple image IDs

    const restaurant = {
      id: generateRestaurantUUID(i),
      name: name,
      chineseName: chineseName,
      category: category,
      location: location,
      locationName: locationNames[location],
      rating: Math.round(rating * 10) / 10,
      reviewCount: 50 + Math.floor(Math.random() * 600),
      image: `https://images.unsplash.com/photo-${imageId}?w=400&h=300&fit=crop&q=80`,
      cuisine: selectedCuisines,
      priceRange: priceRange,
      deliveryTime: `${deliveryTimeStart}-${deliveryTimeEnd}`,
      deliveryFee: deliveryFee,
      minOrder: priceRange === '$' ? 30 + Math.floor(Math.random() * 40) : 
                priceRange === '$$' ? 60 + Math.floor(Math.random() * 60) : 
                120 + Math.floor(Math.random() * 100),
      distance: Math.round(distance * 10) / 10,
      popular: popular,
      topChart: i
    };

    restaurants.push(restaurant);
  }

  return restaurants;
};

export const restaurants = generateRestaurants(); 